
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/zmien-kod-poufny",
      function () {
        return require("private-next-pages/moje-konto/zmien-kod-poufny.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/zmien-kod-poufny"])
      });
    }
  